module.exports = __webpack_public_path__ + "img/code2.40ff1d42.png";